import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Navbar from '@/sections/Navbar';
import Hero from '@/sections/Hero';
import StorySection from '@/sections/StorySection';
import MenuSection from '@/sections/MenuSection';
import AboutSection from '@/sections/AboutSection';
import Footer from '@/sections/Footer';
import AdminPanel from '@/pages/AdminPanel';

function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <MenuSection />
        <StorySection />
        <AboutSection />
      </main>
      <Footer />
      <Toaster position="top-right" toastOptions={{ style: { background: '#1a1a1a', border: '1px solid rgba(255, 215, 0, 0.3)', color: 'white' } }} />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-background korean-pattern">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
